module.exports = __webpack_public_path__ + "static/media/证10拷贝.27599405.png";